import { VisibilityState } from '@tanstack/react-table';
import { outreach } from '@round/api';
import { TikTokProfileEmbed } from '@round/creatorbase-helpers/components';
import { CreatorDetailsPanel } from '../CreatorDetailsPanel/CreatorDetailsPanel';
import styles from './ExpandedResultContent.module.css';

type Props = {
    result: outreach.OutreachResult;
    columnVisibility: VisibilityState;
};

/** What a result's row expands into: its TikTok embed, and a panel of its stats and actions beside it. */
export const ExpandedResultContent = ({ result, columnVisibility }: Props) => {
    return (
        <div className={styles.container}>
            <TikTokProfileEmbed username={result.username} />
            <CreatorDetailsPanel result={result} columnVisibility={columnVisibility} />
        </div>
    );
};
